import React, { useContext, useState, useEffect } from "react";
import { store, ASSETS_URL } from "../../Store";
import { Link, useLocation, useHistory } from "react-router-dom";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { CancelRequestController } from "../../../util/cancel-request-controller";
import { DatosFormInstitutoAPI } from "../../../services/api/LoginInstitucional";
import { AccesibilidadContext } from "../../../contexts/AccesibilidadContext";
import useIsMobile from "../../../js/utilities/useIsMobile";

import { ExploreIcon } from "./explore-icon";

/**
 * Componente que retorna el logo de la institución y el icono de home
 * @returns {JSX.Element} NavbarBrand
 */
export const NavbarBrand = ({ textosInterfaz }) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const accebilidadState = useContext(AccesibilidadContext);

  const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";
  const isIndividualUser = state?.cantidadLibros <= 40 && globalState?.state?.cantidadLibros >= 0;
  const location = useLocation();
  const params = useQueryParams();
  const history = useHistory();
  const isMobile = useIsMobile();

  const [esTemaClasico, setEsTemaClasico] = useState(true);
  const [colorOverIcon, setColorOverIcon] = useState(false);

  /*Actualiza el estado de EsTemaClasico. */
  useEffect(() => {
    let tema = accebilidadState?.temaActual !== 'clasico' ? false : true;
    setEsTemaClasico(tema);
  }, [accebilidadState])

  const mostrarLogoGeneral = isLogged && state.datosHeader?.logo != null;

  const logoSrc = state.datosHeader?.logo ? `${ASSETS_URL}${state.datosHeader.logo}` : "/img/logos/logo-sombra.png";
  return (
    <div className={mostrarLogoGeneral ? "content-logo-general" : "content-logo-mkmk mr-5"}>
      <Link
        to={"/"}
        className="logo focusable-red"
        aria-label={textosInterfaz?.logo_alt || "MakeMake página de inicio"}
      >
        <div className="img-general-logo">
          <img
            alt={""}
            aria-hidden={true}
            src={logoSrc}
          />
        </div>
      </Link>
    </div>
  )
}